import * as React from 'react';
import { Autocomplete, Box, Button, Paper, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { updatetoc, updaterole } from "../../../stores/settingsslice";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";
import { useEffect, useState } from "react";
import Grid from '@mui/material/Unstable_Grid2';
import Alert from '@mui/material/Alert';
import settingsService from '../../../data/api/settings.service';
import userService from '../../../data/api/user.service';
import { showsuccessmessage } from '../../../stores/notificationslice';
import authService from '../../../data/api/auth.service';


export default function UserUpdateForm({callback}:{callback:any}) {
  const [tocs, setTocs] = useState<DropdownModel[]>([]);
  const dispatch = useAppDispatch();
  const [selectedToc, setSelectedToc] = useState<DropdownModel | null>(null);
  const [roles, setRoles] = useState<DropdownModel[]>([]);
  const [selectedRole, setSelectedRole] = useState<DropdownModel | null>(null);

  const [userName, setUserName] = useState<string | null>('');
  const [name, setName] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [isCubicUser,setIsCubicUser]=useState<boolean>(false);
  useEffect(() => {
    settingsService.gettocs().then((response) => {
      setTocs(response.data);
    });
    let currentUser=authService.getCurrentUser();
    if(currentUser.TocId=='-99')
      setIsCubicUser(true);
  }, []);
  useEffect(() => {
    userService.getroles().then((response) => {
      setRoles(response.data);
    });
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    userService.createuser(userName??"", name??"", email??"", parseInt(selectedRole?.Id??"", 10),
      selectedToc != null ? parseInt(selectedToc.Id, 10) : null).then((response) => {

        if (response && response.data) {
          dispatch(showsuccessmessage(response.data));
          resetForm();
          callback();
        }
      });
     
  };

  const resetForm=()=>{
    setName("");
    setEmail("");
    setUserName("");
    setSelectedRole(null);
    setSelectedToc(null);
  }



  return (
      <Box component={Paper} sx={{ margin: '8px', padding: '16px', width: 'calc(100% - 32px)' }}>
        <Typography variant='h6'>Add User</Typography>
        <Box component="form"
          autoComplete="off"
          onSubmit={handleSubmit}
        >

          <Box sx={{ width: '100%' }}>
            <Grid xs={11} container my={1} spacing={2} >

              <Grid xs={2}>
                <TextField
                  sx={{ width: '100%' }}
                  size="small"
                  required
                  id="fullname"
                  label="Full Name"
                  helperText="First Name and Surname"
                  name='fullname'
                  onChange={e=>setName(e.target.value)}
                  value={name}
                />
              </Grid>
              <Grid xs={3}>
                <TextField
                  required
                  sx={{ width: '100%' }}
                  id="email"
                  size="small"
                  label="Email"
                  name='email'
                  type='email'
                  value={email}
                  onChange={e=>{setEmail(e.target.value);setUserName(e.target.value.split('@')[0]);}}


                />
              </Grid>
              <Grid xs={2}>
                <TextField
                  required
                  sx={{ width: '100%' }}
                  id="username"
                  size="small"
                  label="User Name"
                  name='username'
                  helperText="Unique Id for login"
                  value={userName??''}
                  onChange={(event) => setUserName(event.target.value)}
                />
              </Grid>

              <Grid xs={2}>
                <Autocomplete
                  id="role-select"
                  sx={{ width: '100%' }}
                  size="small"
                  options={roles}
                  value={selectedRole}
                  autoHighlight
                  getOptionLabel={(option) => option.Description}
                  onChange={(event: any, newValue: DropdownModel | null) => {
                    setSelectedRole(newValue);
                  }}

                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.Description}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Choose a Role"
                      required
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-role',
                      }}
                    />
                  )}
                />
              </Grid>
              {isCubicUser?
              <Grid xs={2}>
                <Autocomplete
                  id="toc-select"
                  sx={{ width: '100%' }}
                  size="small"
                  options={tocs}
                  value={selectedToc}
                  autoHighlight
                  getOptionLabel={(option) => option.Description}
                  onChange={(event: any, newValue: DropdownModel | null) => {
                    setSelectedToc(newValue);
                  }}


                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.Description}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Choose a TOC"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-toc',
                      }}
                    />
                  )}
                />
              </Grid>:null}
              <Grid xs={1} sx={{ justifyContent: 'center' }}>
                <Button type='submit' sx={{ mt: 0 }} variant="contained" >Add</Button>
              </Grid>
            </Grid>


          </Box>
        </Box>


      </Box>
  )
}